import { z } from 'zod';

export const updateAgentParamsSchema = z.object({
  agent_id: z.uuid('Invalid agent ID'),
});

export const updateAgentSchema = z.object({
  name: z.string().min(1, 'Name is required').optional(),
  slug: z
    .string()
    .min(1, 'Slug is required')
    .regex(/^[a-zA-Z0-9-]+$/, 'Slug must contain only letters, numbers, and hyphens')
    .optional(),
  instruction: z.string().min(1, 'Instruction is required').optional(),
});

export type UpdateAgentParamsPayload = z.infer<typeof updateAgentParamsSchema>;
export type UpdateAgentPayload = z.infer<typeof updateAgentSchema>;
